
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M9.961 12.463c.64 0 1.157.517 1.157 1.156v8.79a1.157 1.157 0 01-1.157 1.172H1.157A1.157 1.157 0 010 22.424v-8.805c0-.639.518-1.156 1.157-1.156H9.96zm12.882 0c.639 0 1.157.517 1.157 1.156v8.79a1.157 1.157 0 01-1.157 1.172h-8.79a1.157 1.157 0 01-1.157-1.157v-8.805c0-.639.518-1.156 1.157-1.156h8.79zM1.157 13.547l-.073 8.862 8.863.073c.04 0 .072-.033.072-.073v-8.79l-8.862-.072zm12.896 0l-.072 8.862 8.862.073c.04 0 .072-.033.072-.073v-8.79l-8.862-.072zM9.96 0c.64 0 1.157.518 1.157 1.157v8.79a1.157 1.157 0 01-1.157 1.128H1.157A1.157 1.157 0 010 9.918V1.157C0 .517.518 0 1.157 0H9.96zm12.882 0C23.482 0 24 .518 24 1.157v8.79a1.157 1.157 0 01-1.157 1.128h-8.79a1.157 1.157 0 01-1.157-1.157V1.157c0-.64.518-1.157 1.157-1.157h8.79zM1.157 1.084l-.073 8.863 8.863.072c.04 0 .072-.032.072-.072v-8.79l-8.862-.073zm12.896 0l-.072 8.863 8.862.072c.04 0 .072-.032.072-.072v-8.79l-8.862-.073z"}})])
          )
        }
      }
    